import React from 'react';

import { P } from '@/components/shared/Typography';
import { cn } from '@/lib/utils/cn';
import { formatNumberWithCommas } from '@/lib/utils/formatNumberWithCommas';

interface I_PredictionPriceCountProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  className?: string;
}

function PredictionPriceCount({
  label,
  value,
  icon,
  className
}: I_PredictionPriceCountProps) {
  return (
    <div
      className={cn(
        'px-5 py-4 rounded-xl grid justify-center gap-1.5',
        className
      )}
    >
      <P className="text-sm font-medium leading-tight justify-center">
        {label}
      </P>
      <P icon={icon} className="text-xl font-bold leading-7 justify-center">
        {formatNumberWithCommas(value)}
      </P>
    </div>
  );
}

export default PredictionPriceCount;
